export default __webpack_public_path__ + "static/media/open_large.ff1cff67.svg";